__webpack_require__.p = "/grenoble/";